export var ENTITY = "legal_case";
export var REDUCER_KEY = "LEGAL_CASES_V2";
export var BASE_PATH_ENTITY = "legal-cases";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
